import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Col, Row, Label, FormGroup, Button, CardFooter } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import SweetAlert from "react-bootstrap-sweetalert";
import dayjs from "dayjs";

import TransitionOnLoad from "Components/TransitionOnLoad";
import AppFooter from "Layout/AppFooter";
import AppHeader from "../../../../Layout/AppHeader";
import ThemeOptions from "../../../../Layout/ThemeOptions";
import CustomCalendar from "Components/Calendar";
import DefaultButton from "Components/Buttons/DefaultButton";
import { useUpdateDayParts, useRequestById } from "Api/Coordinator/Verzoeken";
import PageHeading from "Layout/AppMain/PageHeading";

const Calendar = () => {
    const [datesState, setDatesState] = useState([]);
    const [newDates, setNewDates] = useState([]);
    const [gymList, setGymList] = useState([]);
    const [gymData, setGymData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formState, setFormState] = useState({ dateRange: [] });
    const [isDisabled, setIsDisabled] = useState(false);

    const navigate = useNavigate();
    const params = useParams();
    const substitutionId = params.id || "";
    const { trigger: updateDayPartsMutation } = useUpdateDayParts(substitutionId);

    const { data: requestData, mutate } = useRequestById(substitutionId);


    useEffect(() => {
        if (!requestData?.data) return;
        const resultInfo = requestData.data;

        const datesData = resultInfo.list.map((dateElem) => {
            const [day, month, year] = dateElem.day.split("-");

            return {
                date: `${year}/${month}/${day}`,
                dayPart:
                    Object.keys(dateElem.data).length === 2
                        ? "full"
                        : Object.values(dateElem.data)[0].vShift.toLowerCase(),
            };
        });

        setDatesState(datesData);
        setFormState({
            organisationId: resultInfo.iCommunityId,
            schoolId: resultInfo.iSchoolId,
            absentId: resultInfo.iAbsentAdminId,
            groupsId: resultInfo.groupList.map((g) => g.iSubGroupId),
            codeId: resultInfo.iCodeId,
            type: resultInfo.eType,
            planning: resultInfo.iPlanOption,
            label: resultInfo.tExtra,
            user: "coordinator",
            iHowToInformId: resultInfo.iHowToInformId,
            informEmailExtra1: resultInfo.vExtraEmail1,
            informEmailExtra2: resultInfo.vExtraEmail2,
            gym: gymList,
            substitutionNote: resultInfo.vCoOrdComments,
            schedulerNote: resultInfo.vDirComments,
            dateRange: [],
        });
    }, [requestData]);



    useEffect(() => {
        if (datesState.length) gymCalculation();
    }, [datesState]);

    useEffect(() => {
        setFormState((prev) => ({ ...prev, gym: gymList.sort((a, b) => a - b) }));
    }, [gymList]);

    const weekDaysListWOWeekend = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag'];

    const gymCalculation = () => {
        const gym = []
        let dayId = [];
        let sift = [];
        datesState.map(day => {

            let weekDayNum = dayjs(day.date).day();

            if (day.dayPart === "ochtend") {
                dayId = [weekDayNum * 2 - 1]
                sift = [' ochtend'];
            } else if (day.dayPart === "middag") {
                dayId = [weekDayNum * 2]
                sift = [' middag']
            } else {
                dayId = [weekDayNum * 2 - 1, weekDayNum * 2]
                sift = [' ochtend', ' middag']
            }


            let gymObj = sift.map((dayPart, dayPartId) => {
                return {
                    id: dayId[dayPartId],
                    day: weekDaysListWOWeekend[weekDayNum - 1] + dayPart,
                }
            });

            !gym.some(obj => obj.day == gymObj[0].day) && gym.push(...gymObj);
            gym.sort((x, y) => x.id - y.id);
        });
        setGymData(gym);
    }

    const manageGymForNewDays = () => {
        var gym = [];
        let dayId = [];
        let sift = [];
        newDates.map(day => {
            let weekDayNum = dayjs(day.date).day();

            if (day.dayPart === "ochtend") {
                dayId = [weekDayNum * 2 - 1]
                sift = [' ochtend'];
            } else if (day.dayPart === "middag") {
                dayId = [weekDayNum * 2]
                sift = [' middag']
            } else {
                dayId = [weekDayNum * 2 - 1, weekDayNum * 2]
                sift = [' ochtend', ' middag']
            }
            let gymObj = sift.map((dayPart, dayPartId) => {
                return {
                    id: dayId[dayPartId],
                    day: weekDaysListWOWeekend[weekDayNum - 1] + dayPart,
                }
            });

            !gym.some(obj => obj.day == gymObj[0].day) && gym.push(...gymObj);
            gym.sort((x, y) => x.id - y.id);

        });

        datesState.map(day => {

            let weekDayNum = dayjs(day.date).day();

            if (day.dayPart === "ochtend") {
                dayId = [weekDayNum * 2 - 1]
                sift = [' ochtend'];
            } else if (day.dayPart === "middag") {
                dayId = [weekDayNum * 2]
                sift = [' middag']
            } else {
                dayId = [weekDayNum * 2 - 1, weekDayNum * 2]
                sift = [' ochtend', ' middag']
            }

            let gymObj = sift.map((dayPart, dayPartId) => {
                return {
                    id: dayId[dayPartId],
                    day: weekDaysListWOWeekend[weekDayNum - 1] + dayPart,
                }
            });

            !gym.some(obj => obj.day == gymObj[0].day) && gym.push(...gymObj);
            gym.sort((x, y) => x.id - y.id);
        });

        setGymData(gym);
    }


    const manageDays = (daysElemArray) => {
        var dates = newDates;
        const daysElemArrayWOSelected = daysElemArray.filter(dayElem => !dayElem.classList.contains("selected"));
        const checked = (className) =>
            daysElemArrayWOSelected.every(dayElem =>
                dayElem.classList.contains(className)
            )

        daysElemArrayWOSelected.map(dayElem => {
            let date = dayElem.attributes.date.value;
            if (checked("bg-success")) {
                dates.map((value, index) => {
                    if (value.date === date) {
                        dates.splice(index, 1);
                    }
                })
                dates.push({ date: date, dayPart: "ochtend" });
            } else if (checked("bg-warning")) {
                dates.map((value, index) => {
                    if (value.date === date) {
                        dates.splice(index, 1);
                    }
                })
                dates.push({ date: date, dayPart: "middag" });
            } else if (checked("bg-danger")) {
                dates.map((value, index) => {
                    if (value.date === date) {
                        dates.splice(index, 1);
                    }
                })
            } else {
                dates.map((value, index) => {
                    if (value.date === date) {
                        dates.splice(index, 1);
                    }
                })
                dates.push({ date: date, dayPart: "full" });
            }
        })
        setNewDates(dates);
        manageGymForNewDays();
    }

    const manageDate = (day) => {
        let dates = newDates;

        dates.map((value, index) => {
            if (value.date === day.date) {
                newDates.splice(index, 1);
            }
        })

        dates.push(day);
        setNewDates(dates);
        manageGymForNewDays();
    }


    const handleSubmit = () => {
        setIsDisabled(true);

        if (formState.dateRange.length === 0) {
            setShowModal(true);
            return;
        }

        updateDayPartsMutation({
            data: {
                ...formState,
                substitutionId: Number(substitutionId),
            }
        })
            .then((res) => {
                if (res.status === "success") {
                    navigate(`/verzoeken/overzicht/${substitutionId}`);
                    mutate();
                }
            })
            .finally(() => setIsDisabled(false));
    };


    return (
        <Fragment>
            <AppHeader />
            <ThemeOptions />
            <PageHeading />
            <TransitionOnLoad>
                <div className="chat-layout-wrapper">
                    <Card className="main-card">
                        <CardBody className="p-3">
                            <CustomCalendar
                                preselectedData={datesState}
                                prevState={formState}
                                setState={setFormState}
                                manageDays={manageDays} manageDate={manageDate}
                            />

                            <FormGroup row className="mt-5 ms-3">
                                <Label sm={3}>Gym</Label>
                                <Col sm={6}>
                                    <Typeahead
                                        options={gymData}
                                        multiple
                                        labelKey="day"
                                        onChange={(gymNums) =>
                                            setGymList((prev) => [
                                                ...prev,
                                                ...gymNums.map((e) => e.id).filter((e) => !prev.includes(e)),
                                            ])
                                        }
                                    />
                                </Col>
                            </FormGroup>

                            <SweetAlert
                                show={showModal}
                                title="Selecteer minimaal 1 dagdeel"
                                type="warning"
                                onConfirm={() => {
                                    setShowModal(false);
                                    setIsDisabled(false);
                                }}
                            />
                        </CardBody>
                    </Card>
                </div>
            </TransitionOnLoad>

            <div className="chat-layout-footer">
                <CardFooter className="d-block text-center d-flex chat-layout-footer__inner justify-content-end">

                    <div className="d-flex justify-content-end w-100">
                        <Button
                            className="d-flex align-items-center btn-color-style back-btn"
                            size="sm"
                            outline
                            color="primary me-2"
                            onClick={() => navigate(-1)}
                        >
                            Annuleren
                        </Button>

                        <DefaultButton
                            onClick={handleSubmit}
                            type="button"
                            className="ms-2 float-end btn-color-style"
                            disabled={isDisabled}
                        >
                            Toevoegen
                        </DefaultButton>
                    </div>

                </CardFooter>
            </div>

            {/* <AppFooter /> */}
        </Fragment>
    );
};

export default Calendar;